'use strict';

var React = require('react'),
    PageControls = require('../molecules/PageControls'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    FollowUserButton = require('../molecules/FollowUserButton'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    UserStore = require('../stores/UserStore'),
    BackColorMixin = require('../mixins/BackColorMixin'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ContextMenuActionCreators = require('../actions/ContextMenuActionCreators'),
    ContextMenuTypes = require('../constants/ContextMenuTypes'),
    { PropTypes } = React;

var UserPageControls = React.createClass({
  mixins: [
    createStoreMixin(UserStore),
    BackColorMixin,
    PureRenderMixin
  ],

  propTypes: {
    userId: PropTypes.number.isRequired
  },

  getStateFromStores(props) {
    return {
      user: UserStore.get(props.userId),
      isMe: UserStore.isMe(props.userId)
    };
  },

  componentWillReceiveProps(newProps) {
    if (newProps.userId !== this.props.userId) {
      this.setState(this.getStateFromStores(newProps));
    }
  },

  render() {
    var { user, isMe } = this.state;

    return (
      <PageControls>
        {user && !isMe &&
          <PageControls.Container>
            <FollowUserButton user={user}
                              context='PageControls'
                              size='large' />
          </PageControls.Container>
        }

        {user &&
          <PageControls.Container>
            <Button context='PageControls'
                    size='large'
                    color='black'
                    overlay
                    round
                    fill
                    onClick={this.handleShareClick}>
              <Icon name='share'
                    mode='stroke'
                    size='small' />
            </Button>
          </PageControls.Container>
        }
      </PageControls>
    );
  },

  handleShareClick(e) {
    var el = e.target;
    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.USER_SHARE, el, {
      userId: this.props.userId,
      source: AnalyticsSources.USER_PAGE_CONTROLS
    });
  }
});

module.exports = UserPageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/UserPageControls.jsx
 **/